import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import {
  ReportingTemplateRoute,
  ReportingTemplatePathName,
} from '@/modules/ta/reportingtemplate/reportingtemplate.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${ReportingTemplateRoute.REPORTINGTEMPLATES}`,
      name: 'reportingtemplates',
      component: () =>
        import(
          /* webpackChunkName: "reportingtemplates-page" */ './pages/ReportingTemplatesPage.vue'
        ),
    },
    {
      path: `/${ReportingTemplateRoute.REPORTINGTEMPLATES}/new`,
      name: ReportingTemplatePathName.REPORTINGTEMPLATESFORM_NEW,
      component: () =>
        import(
          /* webpackChunkName: "reportingtemplate-form-page" */ './pages/ReportingTemplateFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${ReportingTemplateRoute.REPORTINGTEMPLATES}/:id`,
      name: ReportingTemplatePathName.REPORTINGTEMPLATESFORM,
      component: () =>
        import(
          /* webpackChunkName: "reportingtemplate-form-page" */ './pages/ReportingTemplateFormPage.vue'
        ),
      props: true,
    },
  ],
  Module.REPORTINGTEMPLATE
);
